// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {List} from '../../../features/offers';
import {Routed_tabs} from '../../../comp/tabs';
import {Text} from '../../../comp/text';
import {Button} from '../../../comp/button';
import store from '../../../store.js';
import {g_path} from '../../../utils/path.js';
import {ROUTES} from '../../../utils/constants.js';
import {get_path} from '../util.js';
import * as cns from './offers.module.less';

const PAGE_SIZE = 14;
const PARAMS = {
    size: PAGE_SIZE,
};

function Empty_banner({action}){
    return <div className={cns.empty_banner}>
      <div className={cns.banner_txt}>
        <Text.xxl bold>You haven't {action} any offers yet</Text.xxl>
        <Button className={cns.banner_btn} href={g_path('/'+ROUTES.OFFERS)}>
          Start earning
        </Button>
      </div>
    </div>;
}

function In_progress(){
    const [data,, l, p] = store.use_started_offers(false, PARAMS);
    return <List data={data} loading={l} pagination={p}
      empty_banner={<Empty_banner action="started"/>}/>;
}

function Done(){
    const [data,, l, p] = store.use_completed_offers(false, PARAMS);
    return <List data={data} loading={l} pagination={p}
      empty_banner={<Empty_banner action="completed"/>}/>;
}

const TAB_ITEMS = [{
    to: get_path('/earnings/in-progress'),
    label: 'Tasks in progress',
    component: In_progress
}, {
    to: get_path('/earnings/completed'),
    label: 'Completed tasks',
    component: Done,
}];

function Content(){
    return <Switch>
      {TAB_ITEMS.map(item=><Route key={item.to} path={item.to} exact
        component={item.component}/>)}
      <Redirect to={TAB_ITEMS[0].to}/>
    </Switch>;
}

export function Offers(){
    return <div className={cns.root}>
      <Routed_tabs items={TAB_ITEMS} size="m"/>
      <div>
        <Content/>
      </div>
    </div>;
}
